import {
    CONCILIATION_SETCONCILIATION,
    CONCILIATION_ONCHANGETABLE,
    CONCILIATION_RESET,
} from "./ConciliationConstants";

export const setConciliation = (data) => ({ type: CONCILIATION_SETCONCILIATION, data });
export const setOnChangeTable = (name, value, uniqueKey) => ({ type: CONCILIATION_ONCHANGETABLE, name, value, uniqueKey });
export const setReset = () => ({ type: CONCILIATION_RESET })